import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/sales/auth/AuthContext";

export default function ProtectedRoute({ children, requireBestuurslid = false }) {
  const { ready, isAuthenticated, isBestuurslid } = useAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen w-full grid place-items-center bg-[#0B1521] text-[#94A3B8] text-xs uppercase tracking-[0.22em]"
      >
        Sessie controleren…
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/sales/login" replace state={{ from: location.pathname }} />;
  }

  if (requireBestuurslid && !isBestuurslid) {
    return <Navigate to="/sales" replace />;
  }

  return children;
}
